import { render, staticRenderFns } from "./StudyUserEventBlock.vue?vue&type=template&id=a940178e&scoped=true&"
import script from "./StudyUserEventBlock.vue?vue&type=script&lang=js&"
export * from "./StudyUserEventBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a940178e",
  null
  
)

export default component.exports